import React from 'react';
import { Card, CardContent } from '../ui/card';
import { TrendIndicator } from './chartHelpers';

/**
 * 4-card row showing Claims / Billed / Collected / Patients with vs-period
 * deltas. Renders nothing when comparison data hasn't loaded.
 */
const ComparisonCards = ({ comparison }) => {
  if (!comparison) return null;
  const cards = [
    { key: 'claims', label: 'Claims', value: comparison.current?.claims || 0, prev: comparison.previous?.claims || 0, isCurrency: false },
    { key: 'billed', label: 'Billed', value: comparison.current?.billed || 0, prev: comparison.previous?.billed || 0, isCurrency: true },
    { key: 'paid', label: 'Collected', value: comparison.current?.paid || 0, prev: comparison.previous?.paid || 0, isCurrency: true },
    { key: 'patients', label: 'Patients', value: comparison.current?.patients || 0, prev: comparison.previous?.patients || 0, isCurrency: false },
  ];
  const fmt = (v, isCurrency) => (isCurrency ? `$${v.toLocaleString()}` : v.toLocaleString());
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="comparison-cards">
      {cards.map((c) => (
        <Card key={c.key} className="border-slate-200">
          <CardContent className="pt-4">
            <p className="text-sm text-slate-500">{c.label}</p>
            <div className="flex items-center justify-between mt-1">
              <span className="text-2xl font-bold text-slate-900">{fmt(c.value, c.isCurrency)}</span>
              <TrendIndicator
                value={comparison.changes?.[c.key] || 0}
                trend={comparison.trends?.[c.key] || 'flat'}
              />
            </div>
            <p className="text-xs text-slate-400 mt-1">
              vs {fmt(c.prev, c.isCurrency)} last {comparison.period}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ComparisonCards;
